import * as classNames from 'classnames';
import { fetchTranslate } from '../../../../i18n/i18n';
import { IDs } from '../../../../helpers/IDs';
import { i18n } from '../../../../i18n/i18n';
import { i18nLang } from '../../../../i18n/i18nLang';
import { lazyInject } from '../../../../services/inversify';
import * as React from 'react';
import style from './MehrsprachigkeitMUI.less';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../../core/elements/spinner/WSpinner';

interface MehrsprachigkeitMUIProps extends React.ClassAttributes<any> {
    data: any;
    intern_key2: string;
    itemList: any; // { 'list name' : [ items ] }
}

interface MehrsprachigkeitMUIState {
    item: any;
    showSpinner: boolean;
    auto_uebersetzung: boolean;
    search: string;
    expanded: any;
}

export class MehrsprachigkeitMUI extends React.Component<MehrsprachigkeitMUIProps, MehrsprachigkeitMUIState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showSpinner: false,
            item: null,
            auto_uebersetzung: true,
            search: '',
            expanded: {}
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private itemCount: number = 0;

    componentDidMount(): void {

    }

    render(): JSX.Element {
        if (!this.props.itemList || Object.keys(this.props.itemList).length === 0) {
            return null;
        }// ⭘◉☐☑🗹
        this.itemCount = 0;
        return (
            <div style={{ overflow: 'hidden' }}>
                <div style={{ fontSize: 12, padding: 10, display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <div style={{ flex: 1, maxHeight: 600, maxWidth: 500, overflowY: 'auto' }}>
                            {this.renderHeader()}
                            {this.renderItemList()}
                        </div>
                        <div style={{ marginTop: 10, fontSize: 10, textAlign: 'right', fontStyle: 'italic' }}>
                            {i18n('Hinweise', 'sys')}: <span style={{ fontStyle: 'normal' }}>☐</span> {i18n('Übersetzung vorhanden', 'sys')} &nbsp;&nbsp; <span style={{ fontStyle: 'normal' }}>🗹</span> {i18n('Übersetzung geprüft', 'sys')}.
                        </div>
                    </div>
                    <div style={{ flex: 1, height: 600, maxWidth: 500, paddingLeft: 20 }}>
                        {this.renderSelect()}
                        <div style={{ height: 'inherit', overflowY: 'auto' }}>
                            {this.state.item && this.renderForm()}
                        </div>
                    </div>
                </div>
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div
                style={{
                    display: 'flex', flexDirection: 'row', justifyContent: 'space-between', position: 'sticky', top: 0, paddingBottom: 5,
                    backgroundColor: '#FFF'
                }}
            >
                <div style={{ width: 400 }}>
                    <input
                        style={{ fontSize: 'inherit', padding: '0 5px' }}
                        placeholder={i18n('Suche', 'sys')}
                        type='text'
                        value={this.state.search}
                        onChange={(event: any) => this.setState({ search: event.target.value })}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {i18nLang.languages.map((lang: string) =>
                        <div
                            key={`list_flag_${lang}`}
                            className={classNames(style.flag, style[`flag-${lang}`])}
                        >
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderItemList(): JSX.Element {
        const { itemList } = this.props;
        const { expanded } = this.state;
        return (
            <>
                {Object.keys(itemList).map((liname: string) =>
                    <div
                        key={`item_list_${liname}`}
                    >
                        {liname &&
                            <div
                                style={{
                                    display: 'flex', alignItems: 'center', margin: '5px 0',
                                    backgroundColor: '#DDD', fontWeight: 'bold', cursor: 'pointer'
                                }}
                                onClick={() => {
                                    expanded[liname] = expanded[liname] === undefined ? false : !expanded[liname];
                                    this.setState({ expanded });
                                }}
                            >
                                <div style={{ marginLeft: 5 }}>
                                    {expanded[liname] === undefined || expanded[liname] === true ? '▽' : '▷'}
                                </div>
                                <div style={{ flex: 1, textAlign: 'center' }}>
                                    {i18n(liname, 'sys')}
                                </div>
                            </div>
                        }
                        {itemList[liname].length > 0 && expanded[liname] !== false &&
                            this.renderGroup(itemList[liname], 0)
                        }
                    </div>
                )}
            </>
        );
    }

    renderGroup(data: any[], level: number): JSX.Element[] {
        return data.map((item: any, idx: number) => {
            const children: any[] = item.children || [];
            return (
                <div key={`list_g_${level}_${idx}`}>
                    {this.renderChildren(item, level)}
                    {children.length > 0 && this.renderGroup(children, level + 1)}
                </div>
            );
        });
    }

    renderChildren(item: any, level: number): JSX.Element {
        if (this.state.search && item.name && typeof item.name === 'string' &&
            item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) === -1) {
            return null;
        }
        const trslFnd = this.props.data[IDs.ENT_MEHRSPRACHIGKEIT].find((r: any) => r.intern_key === item.name && r.intern_key2 === this.props.intern_key2);
        this.itemCount++;
        return (
            <div
                style={{
                    display: 'flex', flexDirection: 'row', justifyContent: 'space-between', cursor: 'pointer',
                    backgroundColor: this.itemCount % 2 === 1 ? '#F8F8F8' : '#FFF',
                    ...(this.state.item && this.state.item.name === item.name ? { backgroundColor: 'rgb(204, 255, 204)' } : {})
                }}
                onClick={() => this.setFormItem(item)}
            >
                <div style={{ width: 400, padding: '2px 0' }}>{`${'... '.repeat(level)} ${item.name}`}</div>
                <div style={{ display: 'flex', flexDirection: 'row', paddingRight: 2 }}>
                    {i18nLang.languages.map((lang: string) =>
                        <div
                            key={`list_c_${this.itemCount}_${lang}`}
                            style={{ fontSize: 14, textAlign: 'center', width: 30, borderLeft: '1px solid #DDD', boxSizing: 'border-box' }}
                        >
                            {trslFnd && trslFnd[lang] && trslFnd[`${lang}_geprueft`] === 1 ? '🗹' :
                                trslFnd && trslFnd[lang] ? '☐' : ''}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    async setFormItem(item: any) {
        this.setState({ item: null });
        if (!item.i18n) {
            item.data = {};
        }
        this.setState({ showSpinner: true });
        const trslFnd = this.props.data[IDs.ENT_MEHRSPRACHIGKEIT].find((r: any) => r.intern_key === item.name && r.intern_key2 === this.props.intern_key2);
        if (trslFnd && trslFnd.tid > 0) {
            item.data = { ...trslFnd };
        } else {
            item.data = {
                tid: 0,
                intern_key: item.name,
                intern_key2: this.props.intern_key2
            };
        }
        const cbDone = () => {
            this.setState({ item, showSpinner: false });
        };
        if (this.state.auto_uebersetzung) {
            // for (const lang of i18nLang.languages) {
            //     if (!item.data[lang]) {
            //         item.data[lang] = await fetchTranslate(item.name, lang);
            //     }
            // }
            // Parallel ist schneller
            const langsFiltered = i18nLang.languages.filter((lang: string) => lang !== 'de' && !item.data[lang]);
            if (langsFiltered.length > 0) {
                let sendCount: number = 0;
                langsFiltered.forEach((lang: string) => {
                    sendCount++;
                    fetchTranslate(item.name, lang, (tsl: string) => {
                        sendCount--;
                        item.data[lang] = tsl;
                        if (sendCount === 0) {
                            cbDone();
                        }
                    });
                });
            } else {
                cbDone();
            }
        } else {
            cbDone();
        }
    }

    renderSelect(): JSX.Element {
        return (
            <div style={{ paddingBottom: 5 }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input
                        type='checkbox'
                        checked={this.state.auto_uebersetzung}
                        onChange={(event: any) => {
                            this.setState({ auto_uebersetzung: event.target.checked }, () => {
                                if (this.state.auto_uebersetzung && this.state.item) {
                                    this.setFormItem(this.state.item);
                                }
                            });
                        }}
                    />
                    {i18n('Automatische Übersetzung', 'sys')}
                </label>
            </div>
        );
    }

    renderForm(): JSX.Element {
        const { item } = this.state;
        const propsLang = this.props.data.LANGUAGE_SELECTED || 'de';
        return (
            <div
                key={`wform_${item.name}_${propsLang}`}
            >
                <WFormsTableWrapper
                    entity={IDs.ENT_MEHRSPRACHIGKEIT}
                    module={IDs.MOD_ETOOL_ADMIN}
                    directEditFormularOf={{ ...item.data }}
                    hideTitel
                    inlineFormular
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    formLayout2={'noneAutoSave'}
                    customFormConfig={{
                        intern_key: { readonly: true },
                        intern_key2: { hidden: true }
                    }}
                    onSaveDone={(entity: string, values: any, bundle: any, saveTid: number) => {
                        this.setState({ showSpinner: true, item: null }, () =>
                            this.triggerService.fire('admin_reload', IDs.ENT_MEHRSPRACHIGKEIT, (rows: any) => {
                                item.data = { ...item.data, ...values };
                                if (saveTid > 0) {
                                    item.data.tid = saveTid;
                                }
                                this.setState({ showSpinner: false, item });
                            }));
                    }}
                />
            </div>
        );
    }
}
